import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  ModalContinueActionButton,
  MODAL_CONTINUE_ACTIONS,
  MODAL_OVERLAY_TYPE,
} from '@models/modal-overlay.class';

@Component({
  selector: 'hb-modal-overlay',
  templateUrl: './modal-overlay.component.html',
  styleUrls: ['./modal-overlay.component.scss'],
})
export class ModalOverlayComponent implements OnInit {
  @Input() actionButtons?: Array<ModalContinueActionButton>;
  @Input() modalType: MODAL_OVERLAY_TYPE;
  @Input() disabledMainActionButton = false;
  @Output() buttonClickEmitter: EventEmitter<MODAL_CONTINUE_ACTIONS> =
    new EventEmitter();

  public modalContinueActions = MODAL_CONTINUE_ACTIONS;
  public modalOverlayType = MODAL_OVERLAY_TYPE;

  constructor() {}

  ngOnInit() {}

  public onButtonClick(type: MODAL_CONTINUE_ACTIONS): void {
    this.buttonClickEmitter.emit(type);
  }
}
